import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SnotifyService } from 'ng-snotify';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

import { UsersTypes } from '../_enums';
import { modalMessages } from '../_models';
import { AcademicYearsService } from '../_services';
import { BaseInjector } from '../_services/base-injector.service';
import { MainFiltersInterface, MainFiltersService } from '../_services/main-filters.service';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { ConfirmMessageComponent } from '../templates/confirm-message/confirm-message.component';
import { SpinnerComponent } from '../templates/spinner/spinner.component';

declare var $;
@Component({
  selector: 'app-base',
  template: ''
})
export class BaseComponent {
  public static spinner: SpinnerComponent;
  @Output('tableAction')
  public appSettings: AppSettings;
  public settings: Settings;
  public currentUser: any;
  public UserTypesEnum = UsersTypes;
  tableAction = new EventEmitter();
  public translateService: TranslateService;
  // public TranslatePipe: TranslatePipe;

  public bsModalService: BsModalService;
  public toastr: ToastrService;
  public snotify: SnotifyService;
  public mainFilterSvc: MainFiltersService;
  public AcadmicYearsSvc: AcademicYearsService;
  public loader: boolean = false;
  mainFilterObservable$: Observable<any>;
  mainFilter: MainFiltersInterface = {
    academicYearId: null,
    programId: null,
    schoolId: null,
    academicSemesterId: null
  };
  constructor() {
    this.appSettings = BaseInjector.injector.get(AppSettings);
    this.settings = this.appSettings.settings;

    this.bsModalService = BaseInjector.injector.get(BsModalService);
    this.toastr = BaseInjector.injector.get(ToastrService);
    this.snotify = BaseInjector.injector.get(SnotifyService);
    this.translateService = BaseInjector.injector.get(TranslateService);
    this.mainFilterSvc = BaseInjector.injector.get(MainFiltersService);
    this.AcadmicYearsSvc = BaseInjector.injector.get(AcademicYearsService);
    this.mainFilterObservable$ = this.mainFilterSvc.getMainFilter();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  componentMsgs: modalMessages = {
    singularLocalizedName: '',
    pluralLocalizedName: '',
    confirmMsg: '',
    deleteMsg: ''
  };

  // selectedItemAction(event) {
  //   this.tableAction.emit(event.operation);
  // }

  succsNotifier() {
    this.toastr.success('Email sent succssfilly', '', { progressBar: false });
  }

  showConfirmYesNoMessage(messageText: string, title: string, confirmOkCallback?, confirmNoCallback?) {
    const modalService = this.bsModalService.show(ConfirmMessageComponent, {
      animated: true,
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered model-dialog  modal-lg',
      initialState: {
        title: title,
        message: messageText,
        okButtonText: 'Common.Yes',
        cancelButtonText: 'Common.No',
        okCallback: confirmOkCallback,
        cancelCallback: confirmNoCallback
      }
    });

    // combineLatest(
    //   this.translateService.get(messageText),
    //   title && title.length > 0 ? this.translateService.get(title) : Observable.of(''),
    //   this.translateService.get('Common.Yes'),
    //   this.translateService.get('Common.No')
    // ).subscribe(translated => {
    //   this.snotify.confirm(translated[0], translated[1], {
    //     timeout: 0,
    //     showProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     position: 'centerCenter',
    //     backdrop: 0.3,
    //     titleMaxLength: 25,
    //     buttons: [
    //       {
    //         text: translated[2],
    //         bold: true,
    //         action: () => {
    //           if (confirmOkCallback)
    //             confirmOkCallback();
    //         }
    //       },
    //       {
    //         text: translated[3],
    //         action: () => {
    //           if (confirmNoCallback)
    //             confirmNoCallback();
    //         }
    //       }
    //     ]
    //   });
    //   $(':focus').blur();
    // });
  }

  canAddAcademics() {
    return (
      this.mainFilterSvc.globalFilterObj.schoolId > 0 &&
      this.mainFilterSvc.globalFilterObj.academicYearId > 0 &&
      this.mainFilterSvc.globalFilterObj.programId > 0 &&
      this.mainFilterSvc.globalFilterObj.educationalProgramId > 0
    );
  }

  showConfirmOkMessage(messageText: string, title: string, confirmOkCallback?) {
    this.bsModalService.show(ConfirmMessageComponent, {
      animated: true,
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered model-dialog  modal-lg medium_size',
      initialState: {
        title: title,
        message: messageText,
        okButtonText: 'AcademicModule.Ok',
        okCallback: confirmOkCallback
      }
    });

    // combineLatest(
    //   this.translateService.get(messageText),
    //   title && title.length > 0 ? this.translateService.get(title) : Observable.of(''),
    //   this.translateService.get('AcademicModule.Ok')
    // ).subscribe(translated => {
    //   this.snotify.confirm(translated[0], translated[1], {
    //     timeout: 0,
    //     showProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     position: 'centerCenter',
    //     backdrop: 0.3,
    //     buttons: [
    //       {
    //         text: translated[2],
    //         bold: true,
    //         action: () => {
    //           if (confirmOkCallback) confirmOkCallback();
    //         }
    //       }
    //     ]
    //   });
    //   $(':focus').blur();
    // });
  }

  showSuccess(message: string, cssClass: string = '', timeoutMs: number = 3000, progressBar: boolean = false) {
    let positionClass: string = 'toast-top-right';
    if (this.settings.rtl) positionClass = 'toast-top-left';
    this.translateService.get(message).subscribe(msg => {
      this.toastr.success(msg, '', {
        progressBar: progressBar,
        timeOut: timeoutMs,
        toastClass: 'ngx-toastr ' + cssClass,
        positionClass: positionClass
      });
    });
  }

  showWarning(message: string, cssClass: string = '', timeoutMs: number = 3000, progressBar: boolean = false) {
    let positionClass: string = 'toast-top-right';
    if (this.settings.rtl) positionClass = 'toast-top-left';
    this.translateService.get(message).subscribe(msg => {
      this.toastr.warning(msg, '', {
        progressBar: progressBar,
        timeOut: timeoutMs,
        toastClass: 'ngx-toastr ' + cssClass,
        positionClass: positionClass
      });
    });
  }

  showError(message: string, cssClass: string = '', timeoutMs: number = 3000, progressBar: boolean = false) {
    let positionClass: string = 'toast-top-right';
    if (this.settings.rtl) positionClass = 'toast-top-left';
    this.translateService.get(message).subscribe(msg => {
      this.toastr.error(msg, '', {
        progressBar: progressBar,
        timeOut: timeoutMs,
        toastClass: 'ngx-toastr ' + cssClass,
        positionClass: positionClass
      });
    });
  }

  getImage(imageName: string) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return  currentUser ? currentUser.fileUrl + '/' + imageName + currentUser.sasToken : null;
  }
}
